import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/service-areas")({
  head: () => ({
    meta: [
      { title: "Service Areas | Pretty in Pink Cleaning Service" },
      {
        name: "description",
        content:
          "Pretty in Pink Cleaning Service serves Wetumpka, Millbrook, Prattville, Montgomery, Tallassee, and Eclectic, AL. See if we clean near you.",
      },
      {
        property: "og:title",
        content: "Service Areas | Pretty in Pink Cleaning Service",
      },
      {
        property: "og:description",
        content:
          "Serving Wetumpka, Millbrook, Prattville, Montgomery, Tallassee, and Eclectic, AL.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: () => <Outlet />,
});
